import { LoadState } from "../../constants/enums";

export interface IProjectState {
  list: IProject[];
  totalRecords: number;
  loading: LoadState;
  projectDetails: IProject;
  projectDetailsLoading: LoadState;
  projectDetailsError: string | null;
  projectSummaryList: IProjectSummary[];
  projectSummaryLoading: LoadState;
  projectSummaryTotalRecords: number;
  projectTempList: ITempProject[];
  projectTempLoading: LoadState;
  projectTempTotalRecords: number;
  projectTemp: ITempProject;
}

export interface ITempProject {
  temp_project_id: number | null;
  project_code: string | null;
  file_path: string;
  file_type: "EXCEL" | "Pdf" | "Excel";
  project_name: string;
  project_instructions: string;
  template_mapping_data: {
    [key: string]: string;
  };
  comment: string;
  status: "ACTIVE" | "INACTIVE";
   // read only
   create_ts?: string;
   insert_ts?: string;
}

export interface IProjectSummary {
  project_id: number;
  project_code: string;
  policy_number: string;
  claim_number: string | null;
  insured_name: string | null;
  date_of_loss: string | null;
  brokerage_name: string;
  branch_code: string | null;
  producer_code: string | null;
  description: string | null;
  assigned_to: string | null;
  item_status: string | null;
  lob: string | null;
  lob_code: string | null;
  broker_number: string;
  name: string | null;
  insurer_branch_code: string | null;
  operating_name: string | null;
  sub_broker: string | null;
  client_name: string | null;
  effective_date: string | null;
  expiry_date: string | null;
  transaction_type: string | null;
  year: string | null;
  make: string | null;
  model: string | null;
  vin: string | null;
  unit: string | null;
  lpn: string | null;
  acv: string | null;
  radius: string | null;
  producer: string | null;
  branch: string | null;
  retail_group: string | null;
  overland_water: string | null;
  overland_water_zone: string | null;
  sewer_back: string | null;
  will_receive_letter: string | null;
  liability_limit: string | null;
  accident_forgiveness: string | null;
  hnw: string | null;
  province: string | null;
  mortgage: string | null;
  grc: string | null;
  earthquake: string | null;
  fsa: string | null;
  high_risk: string | null;
  tag: string | null;
  install_vpn: string | null;
  surcharge: string | null;
  surcharge_code: string | null;
  loss_year: string | null;
  case_type_of_loss: string | null;
  gross_insured_claims: string | null;
  net_insured_claims: string | null;
  gross_current: string | null;
  gross_opening: string | null;
  gross_paid_expenses: string | null;
  gross_received: string | null;
  claim_status: string | null;
  fault: string | null;
  action_taken: string | null;
  notes: string | null;
  comment: string | null;
  status: string;
  created_by_id: number;
  created_by_name: string;
  modified_by_id: number;
  modified_by_name: string;
  create_ts: string;
  insert_ts: string;
}

export interface IProject {
  affectedRows: number;
  changedRows: number;
  fieldCount: number;
  info: string;
  insertId: number;
  serverStatus: number;
  warningStatus: number;
}

export interface IAIProjectDocument {
  project_code: string | null;
  file_path: string;
  file_type: "EXCEL" | "Pdf" | "Excel";
  status: "ACTIVE" | "INACTIVE";

  template_mapping_data: any;
  project_name?: string;
  project_instructions?: string;
  // read only
  create_ts?: string;
  insert_ts?: string;
}

export const initialProjectState: IProjectState = {
  list: [],
  totalRecords: 0,
  loading: LoadState.NotLoaded,
  projectDetails: {
    affectedRows: 0,
    changedRows: 0,
    fieldCount: 0,
    info: "",
    insertId: 0,
    serverStatus: 0,
    warningStatus: 0,
  },
  projectDetailsLoading: LoadState.NotLoaded,
  projectDetailsError: null,
  projectSummaryList: [],
  projectSummaryLoading: LoadState.NotLoaded,
  projectSummaryTotalRecords: 0,
  projectTempList: [],
  projectTempLoading: LoadState.NotLoaded,
  projectTempTotalRecords: 0,
  projectTemp: {
    temp_project_id: 0,
    project_code: "",
    file_path: "",
    file_type: "EXCEL",
    template_mapping_data: {},
    comment: "",
    status: "ACTIVE",
    project_name: "",
    project_instructions: "",
  },
};
